var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cancel copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "as-per-new-designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.09752881,5.50540942 L9.82071195,2.78213053 C10.284458,2.31836907 10.284458,1.56646328 9.82071185,1.10270188 C9.35696574,0.638940471 8.60508475,0.638940427 8.14133858,1.10270178 L5.41814951,3.82598067 L2.69496043,1.10270178 C2.23121428,0.638940333 1.47933321,0.638940333 1.01558706,1.10270178 C0.551840912,1.56646322 0.551840912,2.31836909 1.01558706,2.78213053 L3.73875239,5.50540942 L1.01556331,8.22868831 C0.715572091,8.52868935 0.598412163,8.96595044 0.70821654,9.37575953 C0.818020917,9.78556863 1.1381077,10.105666 1.54790328,10.215474 C1.95769886,10.325282 2.39494553,10.2081182 2.69493667,9.90811706 L5.41812575,7.18483817 L8.14131483,9.90811706 C8.605061,10.3718784 9.35694199,10.3718784 9.8206881,9.90811696 C10.2844342,9.44435556 10.2844343,8.69244977 9.8206882,8.22868831 L7.09752881,5.50540942 Z",
    id: "cancel-copy",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.07ee437c9359330fdd03582405e38e7b.svg";
export { ForwardRef as ReactComponent };